import { render } from "./Confirm2.vue?vue&type=template&id=673bc55a&ts=true"
import script from "./Confirm2.vue?vue&type=script&lang=ts"
export * from "./Confirm2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__